import VueRouter from 'vue-router'
import Web from '../views/Web.vue'

// Lazy load secondary pages for better performance
const Car = () => import(/* webpackChunkName: "car" */ '../views/Car-view.vue')
const MyCars = () => import(/* webpackChunkName: "my-cars" */ '../views/My-cars.vue')
const CarSold = () => import(/* webpackChunkName: "car-sold" */ '../views/Car-sold.vue')
const Legal = () => import(/* webpackChunkName: "legal" */ '../views/forms/LegalForm.vue')
const Cookies = () => import(/* webpackChunkName: "legal" */ '../views/forms/CookiesForm.vue')
const Privacy = () => import(/* webpackChunkName: "legal" */ '../views/forms/PrivacyForm.vue')

const routes = [
    {
        path: '/',
        component: Web,
        name: 'web',
    },
    {
        path: '/cotxe-venda/:car_id',
        component: Car,
        name: 'car',
    },
    {
        path: '/meus-cotxes',
        component: MyCars,
        name: 'my_cars',
    },
    {
        path: '/cotxe-venut/:car_id',
        component: CarSold,
        name: 'car_sold',
    },
    {
        path: '/avis-legal',
        component: Legal,
        name: 'legal',
    },
    {
        path: '/cookies',
        component: Cookies,
        name: 'cookies',
    },
    {
        path: '/privadesa',
        component: Privacy,
        name: 'privacidad',
    }



]

const router = new VueRouter({
    mode: 'history',
    routes
  })

  export default router

